const StorageConstants = {
    IP_PRINTER: 'IP_PRINTER',
    IS_RINGING_LONGER_ACTIVATED :'IS_RINGING_LONGER_ACTIVATED'
}

export default StorageConstants;